import React, { useState } from "react";
import { inject, observer } from "mobx-react";

import { Modal } from "components/modal/compound/Modal";
import styled from "@emotion/styled";
import { Button } from "components/ui/Button";
import {fn_devliery_connect_add_reset} from "function/FnBodyDelivery";

interface Props {
  open: boolean;
  close: () => void;
  title: string;
  text: string;
  onConfirm?: (phoneNumber: string) => void;
  rootStore: any;
}

const DlvNumModal = ({ open, close, title, text, onConfirm, rootStore }: Props) => {
  const [phoneNumber, setPhoneNumber] = useState<string>("");

  if (!open) return null;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setPhoneNumber(numericValue);
  };

  const handleConfirmClick = () => {
    onConfirm?.(phoneNumber);
    close();
  };


  const handleClose = () => {
    const { settingStore, deliveryStore } = rootStore;

    fn_devliery_connect_add_reset(rootStore);
    settingStore.setDlvConnectResult("");
    deliveryStore.setDlvConnectCode([]);

    close();
  };

  return (
    <Modal.BackGround containerWidth="374px" containerHeight="529px" border={true}>
      <ModalWrap>
        <Modal.Header title={title} onClose={handleClose} />

        <ContentWrap>
          <ContentTopTitle>{text}</ContentTopTitle>
          <ContentTopTitle>매장 전화번호를 입력해주세요</ContentTopTitle>
          <Spacer height="24px" />
          <>
            <ContentTopTxt>매장 전화번호</ContentTopTxt>
          </>
          <Spacer height="8px" />

          <Input value={phoneNumber} onChange={handleInputChange} maxLength={11} placeholder="숫자만 입력하세요" />
        </ContentWrap>

        <Divider />

        <Modal.Bottom>
          <Button variant="white" size="sm" onClick={close}>
            취소
          </Button>
          <Button variant="black" size="sm" disabled={phoneNumber.length < 1} onClick={handleConfirmClick}>
            입력하기
          </Button>
        </Modal.Bottom>
      </ModalWrap>
    </Modal.BackGround>
  );
};

export default inject("rootStore")(observer(DlvNumModal));

interface SpacerProps {
  height?: string;
}

const ModalWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: inherit;
`;

const ContentWrap = styled.div`
  padding: 16px 16px 0 16px;
  flex: 1;
`;

const ContentTopTitle = styled.div`
  color: #000;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
`;

const Spacer = styled.div<SpacerProps>`
  height: ${({ height }) => height || "24px"};
  flex-shrink: 0;
`;

const ContentTopTxt = styled.div`
  color: #555c62;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
`;

const Divider = styled.div`
  height: 1px;
  background: #d9d9d9;
  margin: 0 16px;
`;

const Input = styled.input`
  width: 100%;
  height: 50px;
  padding: 8px 18px 9px 12px;
  border: 1px solid #b2b3b4;
  border-radius: 4px;
  box-sizing: border-box;

  font-size: 16px;
  font-weight: 700;
  color: #000;

  &:focus {
    border: 2px solid #000;
  }

  &::placeholder {
    font-weight: 400;
  }
`;
